
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 490.735 490.735"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M254.464 470.039l-59.5-174.2-174.3-59.6c-26.7-9.1-27.8-46.4-1.7-57.1l429.5-176.7c25.1-10.3 50.2 14.8 39.9 39.9l-176.8 429.4c-10.7 26.1-48 24.9-57.1-1.7z"}})])
          )
        }
      }
    